import { useEffect, useMemo, useState } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import I18n from 'I18n';
import UIForm from 'UIComponents/form/UIForm';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module '../.... Remove this comment to see the full error message
import CustomFormInputs from 'MeetingsLib/components/input/CustomFormInputs';

// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module '../.... Remove this comment to see the full error message
import FullNameInput from 'ui-addon-i18n/components/FullNameInput';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module '../.... Remove this comment to see the full error message
import BookingFormField from './BookingFormField';
import { useEmailValidation } from '../../hooks/useEmailValidation';
import { DataFetchingClient } from 'data-fetching-client';
import debounce from 'transmute/debounce';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const client = new DataFetchingClient();
const BookingFormFields = ({
  disabled,
  formFields,
  formStateValidation,
  formState,
  setFormValue,
  setAsyncEmailValidationResult,
  isUngatedForAsyncEmailValidation
}) => {
  // We use below state to properly validate email field
  // against api to see if the domain is valid or not
  const [emailFormatValidation, setEmailFormatValidation] = useState('');
  const [emailField, setEmailField] = useState('');
  const [emailToValidate, setEmailToValidate] = useState('');
  const debouncedEmailToValidateChange = useMemo(() => debounce(500, nextVal => setEmailToValidate(nextVal)), [setEmailToValidate]);
  useEffect(() => {
    setEmailField(formState.get('email'));
  }, [formState]);
  useEffect(() => {
    setEmailFormatValidation(formStateValidation.get('email'));
  }, [formStateValidation]);
  useEffect(() => {
    if (!emailFormatValidation) {
      debouncedEmailToValidateChange(emailField);
    }
  }, [debouncedEmailToValidateChange, emailField, emailFormatValidation]);
  const {
    isValid: emailIsValid,
    loading: isValidatingEmail,
    error: emailValidationError
  } = useEmailValidation({
    email: emailToValidate,
    shouldSkip: !isUngatedForAsyncEmailValidation,
    client
  });
  const renderedEmailValidation = useMemo(() => {
    let validationMessage = '';
    if (!isUngatedForAsyncEmailValidation) {
      return validationMessage;
    }
    if (isValidatingEmail) {
      validationMessage = I18n.text('prebook.details.errorHelper.validatingEmail');
    } else if (!emailIsValid && !emailValidationError) {
      validationMessage = I18n.text('prebook.details.errorHelper.email');
    }
    if (setAsyncEmailValidationResult) {
      setAsyncEmailValidationResult(validationMessage);
    }
    return validationMessage;
  }, [isUngatedForAsyncEmailValidation, isValidatingEmail, emailIsValid, emailValidationError, setAsyncEmailValidationResult]);
  const renderField = (fieldName, validation) => {
    return /*#__PURE__*/_jsx(BookingFormField, {
      fieldName: fieldName,
      validation: formStateValidation.get(fieldName) || validation,
      fieldValue: disabled ? '' : formState.get(fieldName),
      isRequired: true,
      fieldLabel: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `prebook.details.field.${fieldName}`
      }),
      setFormValue: setFormValue,
      autocomplete: "on",
      disabled: disabled
    });
  };
  const renderEmailField = () => {
    return renderField('email', renderedEmailValidation);
  };
  const renderCustomFormFields = () => {
    return /*#__PURE__*/_jsx(CustomFormInputs, {
      formFields: formFields,
      formStateValidation: formStateValidation.get('customFormFields'),
      customFormFields: formState.get('customFormFields'),
      onCustomFormFieldChange: setFormValue,
      disabled: disabled
    });
  };
  const renderNameFields = () => {
    return /*#__PURE__*/_jsx(FullNameInput, {
      direction: "row",
      wrap: "wrap",
      givenNameInput: renderField('firstName'),
      familyNameInput: renderField('lastName'),
      disabled: disabled
    });
  };
  const className = "p-bottom-4 p-x-8";
  return /*#__PURE__*/_jsxs(UIForm, {
    className: className,
    children: [renderNameFields(), renderEmailField(), renderCustomFormFields()]
  });
};
export default BookingFormFields;